import { Dialog } from './Dialog';
import { DialogHeader } from './DialogHeader';
import { DialogBody } from './DialogBody';
import { DialogFooter } from './DialogFooter';

(Dialog as any).Header = DialogHeader;
(Dialog as any).Body = DialogBody;
(Dialog as any).Footer = DialogFooter;

export { Dialog };